// Application layer
/**
 * Caso de uso: listar inventario
 * ------------------------------------------------
 * Responsabilidad:
 * - Validar filtros
 * - Aplicar reglas de negocio de lectura
 * - Delegar persistencia al repositorio
 */

import { InventarioRepository } from "../infrastructure/supabase/inventario.repository.js";

export async function listarInventarioUseCase(filtros) {
  return await InventarioRepository.listar(filtros);
}
